import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';

import { getSessionId } from '../../helpers/storageUtils';
import { DatosGenerales } from '../../Models/datosGenerales';
import { bodyException } from '../../Models/exceptionResponse';
import { YATEMENOSDATOS } from '../../routes.constans';
import { ExceptionService } from '../../services/excepciones/exception.service';
import { InactivityService } from '../../services/inactivity/inactivity.service';
import { selectData } from '../../storage/Lead/data.selectors';

// Componentes compartidos
import { BannerAppComponent } from '../banner-app/banner-app.component';
import { FooterAppComponent } from '../footer-app/footer-app.component';

@Component({
  selector: 'app-cotizacion-pausa-inactivo',
  templateUrl: './cotizacion-pausa-inactivo.component.html',
  styleUrls: ['./cotizacion-pausa-inactivo.component.scss'],
  standalone: true,
  imports: [CommonModule, FooterAppComponent, BannerAppComponent],
})
export class CotizacionPausaInactivoComponent implements OnInit, OnDestroy {
  private inactivityService = inject(InactivityService);
  private router = inject(Router);
  private exceptionService = inject(ExceptionService);
  private store = inject(Store);

  private leadData: DatosGenerales | null = null;

  ngOnInit(): void {
    // Suscribirse al store para obtener datos del lead
    this.store.select(selectData).subscribe((data) => {
      this.leadData = data;
    });

    // Stop any previous timer before starting the second one
    this.inactivityService.stopTimer();

    // Start the second inactivity timer (e.g., 30 seconds)
    this.inactivityService.startInactivityTimer(
      YATEMENOSDATOS, // Redirect here on second timeout
      undefined,
      this.inactivityService.getInactivityKeys(), // Reuse keys from the original screen
      undefined,
      'Segunda inactividad - Pantalla de pausa',
      undefined,
      true, // useSecondTimer = true
      undefined,
      'CotizacionEnPausa',
    );
  }

  goBack(): void {
    console.log('User returning - saving data and resetting inactivity states');
    this.inactivityService.stopTimer();
    window.history.back();
  }

  /**
   * Handles the 'Contactar asesor' button click.
   * Sends an exception with the user's data and navigates to the final page.
   */
  contactarAsesor(): void {
    console.log('🔔 Usuario solicitó contacto con asesor. Enviando excepción de rescate...');
    this.inactivityService.stopTimer();

    const sessionId = getSessionId().toString();
    const leadId = this.leadData?.LeadResponse?.data?.Id || '';
    const originalScreenName = this.inactivityService.getOriginalScreenName();

    console.log('🔍 Debug - Datos del lead para rescate:', {
      leadData: this.leadData,
      mobile_phone: this.leadData?.Lead?.mobile_phone,
      name: this.leadData?.Lead?.name,
      plate: this.leadData?.Lead?.plate,
      leadId: leadId,
      originalScreenName: originalScreenName,
    });

    // Construir el payload completo con todos los datos (igual que en autos)
    const exceptionPayload: bodyException = {
      required_status: this.inactivityService.getOriginalLeadRequirement(),
      percentege_lead: Number(this.inactivityService.getOriginalScreenPercentage()),
      mobile_phone: this.leadData?.Lead?.mobile_phone || '',
      product: 'Motos Digital',
      name: this.leadData?.Lead?.name || '',
      plate: this.leadData?.Lead?.plate || '',
      estadoRetoma: 'Inhabilitado',
      estadoRescate: 'Habilitado',
      pantalla: originalScreenName,
      UrlRetoma: this.inactivityService.getOriginalUrl(),
      session_id: sessionId,
    };

    console.log(
      '📤 Enviando payload de excepción de rescate con todos los datos:',
      exceptionPayload,
    );

    // Determinar si debe enviar lead_id (NO enviarlo en la primera pantalla - Cotizador)
    const isFirstScreen = originalScreenName === 'Cotizador';
    const leadIdToSend = isFirstScreen ? '' : leadId;

    console.log(
      `📋 Pantalla: ${originalScreenName}, Es primera pantalla: ${isFirstScreen}, Lead ID a enviar: "${leadIdToSend}"`,
    );

    this.exceptionService
      .sendGeneralException(sessionId, leadIdToSend, exceptionPayload)
      .subscribe({
        next: (response) => {
          console.log('✅ Excepción de rescate enviada exitosamente:', response);
        },
        error: (error) => {
          console.error('❌ Error al enviar excepción de rescate:', error);
        },
      });

    this.router.navigate([YATEMENOSDATOS]);
  }

  ngOnDestroy(): void {
    this.inactivityService.stopTimer();
  }
}
